// extracted by mini-css-extract-plugin
module.exports = {"background":"BJFXyA","page":"_1x87AX"};